import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../helpers/formatingFunctions";
import UnassignButton from "../../../components/Fleet/UnassignButton/UnassignButton";
import { camelCaseToSentenceCase } from "../../../helpers/camelCaseToSentenceCase";

export const assignedDriverTableColumns: GridColDef[] = [
  { field: "firstName", headerName: "First Name", width: 130 },
  { field: "lastName", headerName: "Last Name", width: 130 },
  { field: "phoneNumber", headerName: "Phone Number", width: 130 },
  {
    field: "driverType",
    headerName: "Driver Type",
    width: 130,
    valueFormatter: (value) =>
      value && camelCaseToSentenceCase(value as string),
  },
  { field: "payee", headerName: "Payee", width: 130 },
  {
    field: "dateAssigned",
    headerName: "Date Assigned",
    width: 130,
    valueFormatter: (value: string) => {
      return value ? formatDate(value) : value;
    },
  },
  {
    field: "dateUnassigned",
    headerName: "Date Unassigned",
    width: 130,
    valueFormatter: (value: string) => {
      return value ? formatDate(value) : value;
    },
  },
  {
    field: "unassignDriver",
    headerName: "",
    width: 200,
    renderCell: (params) => {
      return params.row.dateUnassigned ? null : (
        <UnassignButton
          id={params.row.driverId}
          type="driver"
          truckId={params.row.truckId}
        />
      );
    },
  },
];
